import { render, staticRenderFns } from "./answer.modal.vue?vue&type=template&id=520bcd77&scoped=true"
import script from "./answer.modal.vue?vue&type=script&lang=js"
export * from "./answer.modal.vue?vue&type=script&lang=js"
import style0 from "./answer.modal.vue?vue&type=style&index=0&id=520bcd77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520bcd77",
  null
  
)

export default component.exports